// https://stackoverflow.com/questions/22186467/how-to-use-javascript-eventtarget
function Emitter() {
  var eventTarget = document.createDocumentFragment();
  var dispatchCallbacks = [];

  function delegate(method) {
    this[method] = eventTarget[method].bind(eventTarget)
  }

  [
    'addEventListener',
    //'dispatchEvent',
    'removeEventListener'
  ].forEach(delegate, this);

  this.dispatch = (eventName, detail) => {
    let event = new CustomEvent(eventName, {detail});
    eventTarget.dispatchEvent(event);
    dispatchCallbacks.forEach(func => {
      func(event);
    })
  };

  this.dispatchEvent = (event) => {
    eventTarget.dispatchEvent(event);
    dispatchCallbacks.forEach(func => {
      func(event);
    })
  };


  this.catchAllDispatchEvents = (callback) => {
    dispatchCallbacks.push(callback);
  }
}


export function ChatApiEmitter() {
  Emitter.call(this)
}



const genderList = {
  1: 'Male',
  2: 'Female',
  3: 'Tranny'
};

export function parsePerformer(rawPerformer, serverTime) {
  let performer = Object.assign({}, rawPerformer);

  performer.id = parseInt(performer.id);
  performer.modelCategories = [];
  if (performer.filterData) {
    if (performer.filterData instanceof Array) {
      performer.modelCategories = performer.filterData;
    } else if (performer.filterData instanceof String) {
      performer.modelCategories = performer.filterData.split(',');
    }
  }
  let intBlockedLocations = performer.blocked_locations ? parseBlockedLocations(performer.blocked_locations) : [];
  for (let i = 0; i < intBlockedLocations.length; i++) {
    intBlockedLocations[i] = parseInt(intBlockedLocations[i]);
  }
  performer.blocked_locations = intBlockedLocations;
  performer.country = parseInt(performer.country);
  performer.score = parseInt(performer.score);
  performer.age = parseInt(performer.age);
  performer.region = parseInt(performer.region);
  performer.nationality = parseInt(performer.nationality);
  let langs = [];
  if (performer.language && !(performer.language instanceof Array)) {
    const strLangs = performer.language.replace(/^\<|\>$/g, '');
    langs = strLangs.split('><').map(lng => parseInt(lng, 10));
  }
  performer.language = langs;
  performer.is_new = performer.is_new ? 1 : 0;
  performer.is_test_model = performer.hidden ? 1 : 0;
  if (!isNaN(performer.gender)) performer.gender = genderList[performer.gender];
  //performer.isHiddenByFilter = performer.isHiddenByFilter || false;
  performer.true_private_setting = performer.truePrivateChat || performer.true_private_setting || false;
  performer.vibratip = performer.vibratip || performer.vibraTip || performer.vibratip_setting || false;

  let photo = false;
  if (performer.isPhoto === true || performer.isPhoto === 1 || performer.isPhoto === 'true' || performer.isPhoto === '1') {
    photo = true;
  }
  if (performer.photo === true || performer.photo === 1 || performer.photo === 'true' || performer.photo === '1') {
    photo = true;
  }
  performer.photo = photo;

  performer.public_room = performer.public_room || performer.public_chat_info.room;

  // console.log('parsePerformer result', performer);

  // set stream profile id
  // also in presence-channel:onPresenceAddStream
  if (performer.streams) {
    performer.streams.forEach(stream => fixStreamProfilesId(stream));
  } else {
    performer.streams = [];
  }

  fixPledgeEndTime(performer.pledge_configuration, serverTime);

  return performer;
}

function parseBlockedLocations(bl) {
  if (bl instanceof Array) {
    return bl;
  } else if (bl) {
    const list = [];
    bl.split(',').forEach(v => {
      list.push(parseInt(v, 10));
    });
    return list;
  } else {
    return [];
  }
}

export function fixStreamProfilesId(stream) {
  if (stream && stream.profiles) {
    stream.profiles.forEach((profile, idx) => {
      // add id (key) for all profiles
      profile.id = profile.type + ':' + profile.title + ':' + idx;
    })
  }
}


export function fixPledgeEndTime(pledgeConfiguration, serverTime) {
  if (!pledgeConfiguration) return;
  if (pledgeConfiguration._endTimeFixed) return;
  if (!serverTime) return;
  const timeDiff = (new Date().getTime() / 1000) - serverTime;
  pledgeConfiguration.end_time += timeDiff;
  pledgeConfiguration._endTimeFixed = true;
}

export function exponentialBackoff(toTry, max, delay, callback) {
  console.log('max', max, 'next delay', delay);
  var result = toTry();

  if (result) {
    callback(result);
  } else {
    if (max > 0) {
      return setTimeout(function () {
        exponentialBackoff(toTry, --max, delay * 2, callback);
      }, delay);

    } else {
      console.log('we give up');
    }
  }
}



export function createConsoleLogger(enable, prefix) {
  return enable ? {
    log(...args) {
      args.unshift(prefix);
      console.log(...args);
    },
    info(...args) {
      args.unshift(prefix);
      console.info(...args);
    },
    warn(...args) {
      args.unshift(prefix);
      console.warn(...args);
    },
    error(...args) {
      args.unshift(prefix);
      console.error(...args);
    },
    debug(...args) {
      args.unshift(prefix);
      console.debug(...args);
    },
    group(...args) {
      args.unshift(prefix);
      console.group(...args);
    },
    groupCollapsed(...args) {
      args.unshift(prefix);
      console.groupCollapsed(...args);
    },
    groupEnd(...args) {
      console.groupEnd(...args);
    },
    trace(...args) {
      args.unshift(prefix);
      console.trace(...args);
    }
  } : {
    log() {},
    info() {},
    warn() {},
    error() {},
    debug() {},
    group() {},
    groupCollapsed() {},
    groupEnd() {},
    trace() {},
  };
}
